<template>
	<div class="mainBox">
		<router-view v-if="$route.name && ['entrance', 'login', 'register', 'forget', 'organ', 'error', 'slhSignIn'].includes($route.name)"></router-view>

		<div v-else style="height: 100%">
			<!-- 比如一些模块中自定义页面 -->
			<div
				v-if="
					[
						'/cms/content/articles/pvwp',
						'/cms/content/classify/pvwp',
						'/cms/content/dissertation/preview',
						'/saas/screen/governmentDataScreen',
						'/saas/screen/trainRegulation',
						'/saas/EasyScreen',
						'/saas/zegoroomkit',
						'/custom/certificateQueryPage',
						'/custom/certificateQueryResult'
					].includes(this.currentRouter)
				"
				style="min-height: 100%"
			>
				<div id="appContainer" style="height: 100%; margin-top: 0"></div>
			</div>
			<el-container v-else style="height: 100%">
				<el-header :style="`z-index: 9;height: ${style.headerHeight}px;padding:0px;`" id="main-header">
					<HeaderNew v-if="isNewSaas" :isCollapse="isCollapse" />
					<HEAD v-else :isCollapse="isCollapse" />
				</el-header>
				<el-container>
					<el-aside :style="`width: ${style.containerWidth}px;`">
						<div class="expand" @click="setExpand" v-show="!isCollapse">
							<img :src="style.openeds.length === menuList.length ? style.img.zhankai : style.img.zhedie" />
						</div>

						<MenuNew
							v-if="isNewSaas"
							:style="`
              margin-top: ${isCollapse ? 0 : 8}px;
            `"
							:menuList="menuList"
							:isCollapse="isCollapse"
							:styleData="style"
						/>
						<MENU
							v-else
							:style="`
              margin-top: ${isCollapse ? 0 : 8}px;
            `"
							:menuList="menuList"
							:isCollapse="isCollapse"
							:styleData="style"
						/>
					</el-aside>
					<el-main>
						<div class="breadcrumb-bar" v-show="minzhengShow">
							<span class="tip"> {{ $t('MAIN_WEB_YOUR_CURRENT_LOCATION', { text: '您当前在：' }) }}</span>
							<ul class="breadcrumb">
								<li v-for="(item, index) in breadcrumb" :key="index">
									<span v-if="index" class="cutApart">/</span>
									<a
										:href="index ? item.path : 'javascript:;'"
										:class="`highlight ${index === breadcrumb.length - 1 && 'current'} ${+item.type !== 2 && 'directory'}`"
										>{{ item.title }}</a
									>
								</li>
							</ul>
						</div>
            <iframe style="width: 100%; height: 100%;" v-if="isBiAdmin" :src="biAdminUrl" frameborder="0"></iframe>
						<div v-else id="appContainer"></div>
					</el-main>
				</el-container>
			</el-container>
		</div>
	</div>
</template>

<script>
import MENU from './components/menu'
// import getLanguageData from './locale/locale'
import HEAD from './components/header'
import HeaderNew from './components/header_new'
import MenuNew from './components/menu_new'
import zhankai from './assets/images/zhankai.png'
import zhedie from './assets/images/zhedie.png'
import conf from './config/url.js'
import api from './api'
import theme from '@wd/lowcode-pc/plugin/theme/index'
import cssVars from 'css-vars-ponyfill'
import locale from './locale'
import URL from './config/url'
export default {
	name: 'B',
	components: { MENU, HEAD, HeaderNew, MenuNew },
	data() {
		return {
			style: {
				img: {
					zhankai,
					zhedie,
				},
				openeds: [],
				containerHeight: 0,
				containerWidth: 160,
				headerHeight: 56,
				mainHeight: 0,
				mainWidth: 0,
			},
			isCollapse: false,
			breadcrumb: [],
      minzhengShow: true,
      isBiAdmin: false,
      biAdminUrl: ''
		}
	},

	watch: {
		$route(to, from) {
			console.log(to.name,"main-app-watch=============to.name=============")
      if (document.location.pathname.includes('bi-admin')) {
        let host = URL.env ? `${window.location.protocol}//bi-admin.${URL.env}.wdeduc.com` : `${window.location.protocol}//bi-admin.wdeduc.com`;
        this.biAdminUrl = `${host}${document.location.pathname.replace('/bi-admin', '')}?token=${localStorage.getItem('token')}&actor=${localStorage.getItem('actor')}&organ=${localStorage.getItem('organ')}&channel=${localStorage.getItem('channel') || 1}&branch=${localStorage.getItem('branch')}`
        this.isBiAdmin = true
      } else {
        this.isBiAdmin = false
      }
			this.minzhengData()
			this.getBreadcrumb(this.$route)
        },
        '$store.state.nav': {
            handler(){
                this.getBreadcrumb(this.$route)
            }
        },
        '$store.state.currentLanguage': {
            handler(val){
                if(this.isNewSaas){
                    if(this.isCollapse){//隐藏状态不改变side宽度
                        return
                    }
                    if( val !== 'zh-CN'){
                        this.style.containerWidth = 300
                    }else{
                        this.style.containerWidth = 160
                    }
                }
            }
        }
		// $route: "getBreadcrumb"
	},
	computed: {
		menuList() {
			if (!this.$store.getters.nav || !this.$store.getters.nav.length) return []
			return this.$store.getters.nav
		},
		currentRouter() {
			console.log(this.$store.state.currentRouter,"main-app-currentRouter")
			return this.$store.state.currentRouter
		},
		isNewSaas() {
			return this.$store.state.isNewSaas
		},
	},
	async created() {
		window.addEventListener('resize', this.getHeight)
		this.getHeight()
		await this.getConfiguration()
		document.title =
			localStorage.getItem('pageTitle') ||
			this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
	},
	async mounted() {
		window.addEventListener('resize', this.getHeight)
		this.init()
		// this.getHeight();
		window.onbeforeunload = (e) => {
			if (this.breadcrumb && this.breadcrumb.length) {
				localStorage.setItem('breadcrumb', JSON.stringify(this.breadcrumb))
			}
		}
	},
	destroyed() {
		window.removeEventListener('resize', this.getHeight)
		window.onbeforeunload = null
	},
	methods: {
		async getConfiguration() {
			await this.$api.configuration
				.getConfiguration(conf.confUrl)
				.then(async (res) => {
				    // 配置型存储本地化
					let frontendConfig = res.data.frontendConfig
                    localStorage.setItem(
                        "frontendConfig",
                        res.data && JSON.stringify(res.data.frontendConfig)
                            ? JSON.stringify(res.data.frontendConfig)
                            : ""
                    );
                    sessionStorage.setItem(
                        "frontendConfig",
                        res.data && JSON.stringify(res.data.frontendConfig)
                            ? JSON.stringify(res.data.frontendConfig)
                            : ""
                    );


                    localStorage.setItem(
                        "websiteLogo",
                        res.data && res.data.websiteLogo
                            ? res.data.websiteLogo
                            : ""
                    );
                    sessionStorage.setItem(
                        "websiteLogo",
                        res.data && res.data.websiteLogo
                            ? res.data.websiteLogo
                            : ""
                    );



                    localStorage.setItem(
                        "theme",
                        res.data && res.data.theme
                            ? res.data.theme
                            : ""
                    );
                    sessionStorage.setItem(
                        "domain",
                        res.data && res.data.domain
                            ? res.data.domain
                            : ""
                    );

                    localStorage.setItem(
                        "pageTitle",
                        res.data && res.data.pageTitle
                            ? res.data.pageTitle
                            : ""
                    );
                    sessionStorage.setItem(
                        "pageTitle",
                        res.data && res.data.pageTitle
                            ? res.data.pageTitle
                            : ""
                    );


                    localStorage.setItem(
                        "branchIndustry",
                        res.data && res.data.pageTitle
                            ? res.data.pageTitle
                            : ""
                    );
                    sessionStorage.setItem(
                        "branchIndustry",
                        res.data && res.data.pageTitle
                            ? res.data.pageTitle
                            : ""
                    );



                    frontendConfig.map((item) => {
						if (item.key === 'theme') {
							this.setTheme(item.value)
						}
						if (item.key === 'custom_login_background_img' && item.value) {
							localStorage.setItem('loginBackgroundImg', item.value)
							// this.$store.commit('setLoginBackgroundImg', item.value)
						}
						if (item.key === 'custom_login_img' && item.value) {
							localStorage.setItem('loginImg', item.value)
							// this.$store.commit('setLoginImg', item.value)
						}
						// if(item.key == 'is_i18n'){
						// 	localStorage.setItem('is_i18n', item.value)
						// }
					})
					// this.setTheme('init');
					if (res.data && res.data.websiteLogo) {
						this.$store.commit('setLogo', res.data.websiteLogo)
						localStorage.setItem('websiteLogo', res.data.websiteLogo)
					}
					/** 培训任务数据统计用到 */
					this.$store.commit('setTheme', res.data.theme)
					localStorage.setItem('theme', res.data && res.data.theme)

					localStorage.setItem('domain', res.data && JSON.stringify(res.data.domain) ? JSON.stringify(res.data.domain) : '')
					localStorage.setItem(
						'configurationConfig',
						res.data && JSON.stringify(res.data.frontendConfig) ? JSON.stringify(res.data.frontendConfig) : ''
					)
					const a = res.data.frontendConfig.find((item) => item.key === 'is_open_platform_up_commodity')
					localStorage.setItem('isOpenToPlateform', a.value)
					// await getLanguageData();
					/**  * cms 配置网页标题 */
					if (res.data.pageTitle) {
						localStorage.setItem('pageTitle', res.data.pageTitle)
					}
					await this.documenetTitle()
					// document.title = (res.data && res.data.pageTitle) || this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION',{text:'共享教育资源 传承人类文明'})
				})
				.catch((err) => {
					console.log(err)
					document.title = this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
				})
		},
		documenetTitle() {
			document.title =
				localStorage.getItem('pageTitle') ||
				this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
		},
		setTheme(name) {
			const initTheme = (name) => {
				document.documentElement.setAttribute('data-theme', name)
				cssVars({
					silent: true,
					watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
					variables: theme[name], // variables 自定义属性名/值对的集合
					onlyLegacy: true, // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
				})
			}
			initTheme(name)
		},
		async init() {
			const width = window.innerWidth
			if (width < 1200) {
				this.isCollapse = true
				this.style.containerWidth = 46
			} else {
                this.isCollapse = false
                if(localStorage.getItem('is_i18n') === 'true' && localStorage.getItem('current_language') !== 'zh-CN'){
                    this.style.containerWidth = 300
                }else{
                    this.style.containerWidth = 160
                }
			}
			await this.getBreadcrumb(this.$route)
		},
		setExpand() {
			if (this.style.openeds.length === this.menuList.length) {
				this.style.openeds = []
			} else {
				this.style.openeds = []
				this.menuList.forEach((item) => {
					this.style.openeds.push(`/${item.data.systemTagName}${item.data.url}`)
				})
			}
		},
		minzhengData() {
			let address = window.location.href
			if (address.indexOf('/saas/downtown') !== -1 || address.indexOf('/saas/provincialLevelData') !== -1) {
				this.minzhengShow = false
			} else {
				this.minzhengShow = true
			}
		},
		rollback(item, index) {
			index &&
				index !== this.breadcrumb.length - 1 &&
				item &&
				[2].includes(+item.tapy) &&
				this.$router.push({
					path: item.path,
				})
		},
		setCollapse() {
			this.isCollapse = !this.isCollapse
			if (this.isCollapse) {
				this.style.containerWidth = 46
			} else {
                if(localStorage.getItem('is_i18n') === 'true' && localStorage.getItem('current_language') !== 'zh-CN'){
                    this.style.containerWidth = 300
                }else{
                    this.style.containerWidth = 160
                }
			}
			this.getHeight()
		},
		getHeight() {
			const height = window.innerHeight
			this.style.containerHeight = height
			this.style.mainHeight = this.style.containerHeight - this.style.headerHeight

			const width = window.innerWidth
			const mainWidth = width - this.style.containerWidth - 9
			if (mainWidth <= 960) {
				this.style.mainWidth = 960
				return
			}
			this.style.mainWidth = mainWidth
		},
		async getBreadcrumb(route, oldRoute) {
			// console.log(route,oldRoute,'-------------------------------')
			// console.log('+++++++++++++++++++++++++++',route)
			// 获取跳转到新标签的面包屑
			let breadcrumbArr = route.query.breadcrumbArr && JSON.parse(route.query.breadcrumbArr)
			if (breadcrumbArr) {
				// 跳转新标签面包屑
				this.breadcrumb = breadcrumbArr
			} else if (localStorage.getItem('breadcrumb')) {
				// 解决在子路由页面刷新获取不到面包屑问题
				this.breadcrumb = localStorage.getItem('breadcrumb') && JSON.parse(localStorage.getItem('breadcrumb'))
			}

			const arr = Object.assign([], this.breadcrumb)
			this.breadcrumb = []
			if (this.$store.state.nav && this.$store.state.nav.length) {
                this.setBreadcrumb(route.path, this.$store.state.nav)
                if(localStorage.getItem('is_i18n') === 'true'){
                    this.breadcrumb = []
                    this.reStorageBreadcrumb(this.$store.state.nav)
                }
			}
			if (!this.breadcrumb || !this.breadcrumb.length) {
				this.breadcrumb = arr
			}
			//

			// 多级面包屑
			let childBreadcrumb = route.query.showBreadcrumb && route.query.showBreadcrumb.replace(/\"|\'/g, '')
			// 使用标志位，过滤到自己手动添加的面包屑，下面再重新push
			if (childBreadcrumb) {
				let curItemIndex = this.breadcrumb.findIndex((item) => {
					return item.title === childBreadcrumb
				})
				if (curItemIndex > -1) {
					const preBreadcrumb = this.breadcrumb.filter((item, index) => {
						return !item.flag || index < curItemIndex
					})
					this.breadcrumb = preBreadcrumb
				}
			}

			// 判断是否已经保存,没保存过添加进去
			let isSave = this.breadcrumb.find((item) => item.title === childBreadcrumb)
			if (childBreadcrumb && !isSave) {
				let obj = {
					path: route.fullPath,
					title: childBreadcrumb,
					flag: true, //自己手动添加的面包屑加标志位
				}
				this.breadcrumb.push(obj)
			}
			localStorage.setItem('breadcrumb', JSON.stringify(this.breadcrumb))
		},
		setBreadcrumb(pathStr, nav) {
			// console.log(pathStr,nav,'=============================')
			nav.forEach((item) => {
				if (pathStr === item.path) {
                    this.breadcrumb = item.matched
                    sessionStorage.setItem('pathStr',pathStr)
					// console.log('matched',this.breadcrumb)
				}
				if (this.breadcrumb && !this.breadcrumb.length && item.children && item.children.length) {
					this.setBreadcrumb(pathStr, item.children)
				}
            })
        },
        // 国际化、子页面翻译问题
        reStorageBreadcrumb(nav){
            let path = sessionStorage.getItem('pathStr')
            nav.forEach((item) => {
                if (path === item.path) {
                    this.breadcrumb = item.matched
                }
                if (this.breadcrumb && !this.breadcrumb.length && item.children && item.children.length) {
                    this.reStorageBreadcrumb(item.children)
                }
            })
        }
	},
}
</script>
<style lang="stylus" scoped>
.item-content-user-message-tooltip {
  width: 400px;
}

.mainBox {
  width: 100%;
  height: 100%;
}

#appContainer {
  height: calc(100vh - 60px);
  margin-top: -60px;
  overflow: auto;
}
.el-main {
  padding: 0;
}

.el-aside {
  max-height: calc(100vh - 56px);
  background-color: #ffffff;
  overflow-x: hidden;
}

.expand {
  position: absolute;
  background-color: #fff;
  left: 0;
  height: 8px;
  width: 160px;
  top: 56px;
  z-index: 9;
  font-size: 0;
  text-align: center;

  img {
    margin-top: 1px;
    height: 6px;
  }
}

.breadcrumb-bar {
  position: relative;
  z-index: 8;
  height: 60px;
  width: calc(100% - 40px);
  margin: 0 20px;
  background: #f8f9ff;
  line-height: 60px;

  .tip {
    color: #95accf;
  }

  .breadcrumb {
    display: inline-block;

    li {
      display: inline-block;

      span, a {
        display: inline-block;
        color: #95ACCF;
      }

      .cutApart {
        padding: 0 16px;
        color: #D0D8E7;
        text-align: center;
      }

      .highlight {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      /deep/ .directory {
        &:hover {
          color: #95ACCF;
          cursor: default;
          text-decoration: none;
        }
      }

      /deep/ .current {
        color: #333333;
        cursor: default;
        text-decoration: none;

        &:hover {
          color: #333333;
          cursor: default;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
<style lang="stylus">
@import './assets/css/elDefault.styl'
.el-tooltip__popper {
  max-width: 1000px;
}

.el-tooltip__popper.is-dark {
  max-width: 1000px;
}
.zhiyeCascader {
  .el-cascader-node__label{
    max-width:140px!important;
  }
}
.el-color-loading{
    color: #666 !important;
    .el-loading-spinner{
      color:#666!important;
      .el-icon-loading{
         color:#666 !important;
      }
      .el-loading-text{
        color:#666 !important;
      }
    }
  }
  .el-icon-loading{
    color: #666 !important;
  }
 .el-loading-text {
   color: #666 !important;
  }
  .el-loading-spinner {
     color: #666 !important;
  }
html[data-theme="red"] {
  .highlight{
    color:#EB5461!important
  }
  /deep/.el-color-loading{
    color: #EB5461 !important;
    .el-loading-spinner {
      color: #EB5461 !important;
      .el-icon-loading{
        color: #EB5461 !important;
      }
      .el-loading-text {
      color: #EB5461 !important;
      }
    }
  }
}
html[data-theme="init"] {
  .highlight{
    color:#1972FF!important
  }
  /deep/.el-color-loading{
    color:#1972FF!important
    .el-loading-spinner  {
      color:#1972FF!important
      .el-icon-loading{
        color:#1972FF!important;
      }
      .el-loading-text {
      color:#1972FF!important
      }
    }
  }
}
</style>
